$(function() {

//==========================================================================
// MODULE STATE
//==========================================================================

var $containerNewsHistory = $(".containerNewsHistory");

//==========================================================================
// ENTRY POINT
//==========================================================================

init();

//==========================================================================
// INIT
//==========================================================================

//-----

function init() {
	if (!$containerNewsHistory){
		return;
	}

	$containerNewsHistory.find(".containerMonth").click(function(event){
		var elementMonth = $(this);
		if(elementMonth.hasClass("containerMonth-active")){
			$(".containerMonth").children(".containerMonthNews").slideUp();
			elementMonth.removeClass("containerMonth-active");			
		}
		else {
			$(".containerMonth").removeClass("containerMonth-active");
			$(".containerMonth").children(".containerMonthNews").slideUp();
			elementMonth.children(".containerMonthNews").slideDown();
			elementMonth.addClass("containerMonth-active");	
		}
		setTimeout(function(){
			$('html, body').animate({
			scrollTop: elementMonth.offset().top
			}, 500);
		}, 200);
			
	});
}

//-----

//==========================================================================
// FUNCTIONS
//==========================================================================

//-----



//===== Events =============================================================


//-----

});
